<template>
  <div>
    <h6
      v-if="!isModal"
      class="text-h6 font-weight-medium grey--text text--darken-1 pb-3"
    >
      Tags
    </h6>
    <review-tags-settings-panel
      :review="review"
      :can-edit="true"
      :disabled="loading"
      :small="isModal"
      @createTag="createTag"
      @updateTag="updateTag"
      @deleteTag="requestTagDeletion"
    />
    <confirmation-dialog
      :value="showDeleteConfirmation"
      :disabled="actionInProgress"
      :name="tagToDeleteLabel"
      @confirm="deleteTag(tagToDelete)"
      @input="closeDeleteDialog"
    >
      <div
        v-if="referencesUsingQueriedTag === null"
        class="rtsc-progress-indicator"
      >
        <v-progress-circular
          :size="85"
          indeterminate
          color="grey darken-2"
        />
        <div>Checking for usage</div>
      </div>
      <span v-else-if="referencesUsingQueriedTag.length === 0"
        >Are you sure you wish to delete
        <strong>{{ tagToDeleteLabel }}</strong
        >?
        <br />
        It is not currently in use.
      </span>
      <span v-else>
        Deleting <strong>{{ tagToDeleteLabel }}</strong> will remove
        it from {{ referencesUsingQueriedTag.length }} references for
        which it is currently in use.
      </span>
    </confirmation-dialog>
  </div>
</template>

<script>
import ReviewTagsSettingsPanel from './ReviewTagsSettingsPanel';
import { Review } from '@/models';
import { mapActions } from 'vuex';
import ConfirmationDialog from '@/components/ReviewsPage/ConfirmationDialog';

export default {
  name: 'ReviewTagsSettingsController',
  components: {
    ReviewTagsSettingsPanel,
    ConfirmationDialog,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    actionInProgress: false,
    tagToDelete: null,
    referencesUsingQueriedTag: null,
  }),
  computed: {
    loading() {
      return this.actionInProgress;
    },
    showDeleteConfirmation() {
      return !!this.tagToDelete;
    },
    tagToDeleteLabel() {
      return this.tagToDelete?.label ?? '';
    },
  },
  methods: {
    ...mapActions({
      createReviewTag: 'reviewTag/createReviewTag',
      updateReviewTag: 'reviewTag/updateReviewTag',
      deleteReviewTag: 'reviewTag/deleteReviewTag',
      getReferencesUsingTag: 'reference/getReferencesUsingTag',
    }),
    async lockedAction(callback) {
      if (this.actionInProgress) {
        return;
      }
      this.actionInProgress = true;
      try {
        await callback();
      } finally {
        this.actionInProgress = false;
      }
    },
    async createTag(tag) {
      await this.lockedAction(async () => {
        await this.createReviewTag({
          reviewId: this.review.id,
          label: tag.label,
        });
      });
    },
    async updateTag(tag) {
      await this.lockedAction(async () => {
        await this.updateReviewTag(tag);
      });
    },
    async deleteTag(tag) {
      await this.lockedAction(async () => {
        await this.deleteReviewTag(tag.id);
      });
    },
    async requestTagDeletion(tag) {
      await this.lockedAction(async () => {
        this.referencesUsingQueriedTag = null;
        this.tagToDelete = tag;
        this.referencesUsingQueriedTag = await this.getReferencesUsingTag(
          tag.id
        );
      });
    },
    closeDeleteDialog() {
      this.tagToDelete = null;
    },
  },
};
</script>

<style scoped>
.rtsc-progress-indicator {
  display: grid;
  justify-items: center;
}
</style>
